module.exports = __webpack_public_path__ + "static/media/award2@2x.318023dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/award2@2x.png
// module id = 1125
// module chunks = 0